"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  num: "60%",
  title: "Over-Valuation",
  desc: "Studies indicate that up to 60% of property tax challenges in New York result in a meaningful reduction of the assessment and property tax bill."
}, {
  num: "4M",
  title: "NY RESIDENTIAL",
  desc: "There are over 4 million residential properties in New York with many municipalities having the highest per capita tax rates in the entire United States."
}, {
  num: "50%",
  title: "NY RED TAPE",
  desc: "From 2014 through 2024, the number of Article 7 proceedings declined nearly 50% as New York continues to make the process more complicated and expensive."
}];
export default function TheBrokenSystem() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="177003" id="the-assessment-crisis" className="bg-muted py-20 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,theme(colors.secondary/10%)_1px,transparent_1px),linear-gradient(to_bottom,theme(colors.secondary/10%)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-30 pointer-events-none" />

      <div ref={ref} className={`container mx-auto px-4 md:px-6 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-sans font-extrabold text-secondary mb-6 tracking-tighter">
            The Assessment Crisis
          </h2>
          <p className="text-lg md:text-xl text-secondary/80 leading-relaxed font-sans">
            Assessment Watch investigative audits have uncovered systemic failures in the NY property 
            tax framework. These figures represent the human cost of a broken valuation model.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {pillars.map((pillar, i) => <Card key={i} data-index={i} className="group relative border border-secondary/20 bg-background rounded-none transition-all duration-500 ease-out hover:bg-background hover:border-primary hover:shadow-xl hover:-translate-y-2 overflow-hidden">
              {}
              <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

              <CardHeader className="pb-4 relative z-10">
                <div className="text-6xl md:text-7xl font-mono font-bold text-primary mb-6 opacity-100 transition-opacity drop-shadow-sm">
                  {pillar.num}
                </div>
                <CardTitle className="text-2xl font-sans font-bold tracking-tight uppercase text-secondary group-hover:text-primary transition-colors duration-300">
                  {pillar.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="relative z-10">
                <p className="text-secondary/70 text-justify leading-relaxed group-hover:text-secondary transition-colors duration-300 font-sans">
                  {pillar.desc}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}